import React from 'react';

import { WebinarPlayerContext } from '$/components/WebinarPlayer/context';
import Cursor from '../Cursor/Cursor';
import Markers from '../Markers/Markers';
import RoomMarkers from '../RoomMarkers';

import { usePermissionModal } from '$/components/Permission';
import { useMe } from '$/hooks/useMe';
import { hasPermission } from '$/utils/hasPermission';
import { getRoute, rolesPermissionsMatrix } from '$/utils/pathConfig';
import { ZoomScaleProviderContext } from './ZoomScaleProviderContext';
import { TranslateScrollbar } from './TranslateScrollbar';
import { TimelineTrackLabels } from './TimelineTrackLabels';

export const TimelineTrack: React.FC = () => {
  const me = useMe();
  const { zoomRefCallback, zoom } = React.useContext(ZoomScaleProviderContext);

  const { showPermissionModal } = usePermissionModal();
  const { colors, ewebinar, timelineComponents, isEditingInteractions, interactionInEdit } =
    React.useContext(WebinarPlayerContext);
  const dashboardInteractionsRoute = getRoute(
    rolesPermissionsMatrix.portalDashboardInteractions.path,
    { setId: ewebinar?.id }
  );
  const canAccess = hasPermission(dashboardInteractionsRoute, me);
  const handlePermissionModal = (): void => {
    showPermissionModal && showPermissionModal(dashboardInteractionsRoute);
  };

  return (
    <div
      className='relative z-player-timeline'
      id={`timelineTrack${interactionInEdit ? '-onModal' : ''}`}
    >
      <svg
        ref={zoomRefCallback}
        style={{ width: '100%', overflow: 'visible', position: 'relative' }}
      >
        {/* Order matters here - earlier rendered items are below later rendered */}
        {/* middle bar background */}
        <g>
          <rect
            cursor='pointer'
            y={0}
            x={0}
            height={timelineComponents.time.offset}
            width={zoom!.translateExtent()[1][0]}
            fill={colors.room}
          />
        </g>

        {/* middle and top bar room segregations */}
        <svg style={{ width: '100%', overflow: 'hidden' }}>
          <RoomMarkers />
        </svg>

        {/* bottom time bar */}
        <TimelineTrackLabels />

        {/* interaction bubbles/circles */}
        <Markers
          isEditingInteractions={isEditingInteractions}
          hasPermission={canAccess}
          showPermissionModal={handlePermissionModal}
        />

        {/* cursor */}
        <Cursor isEditingInteractions={isEditingInteractions} />

        {/* scrollbar */}
        <TranslateScrollbar />
      </svg>
    </div>
  );
};
